import { render, staticRenderFns } from "./AddPartnerships.vue?vue&type=template&id=17586ddb&scoped=true"
import script from "./AddPartnerships.vue?vue&type=script&lang=js"
export * from "./AddPartnerships.vue?vue&type=script&lang=js"
import style0 from "./AddPartnerships.vue?vue&type=style&index=0&id=17586ddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17586ddb",
  null
  
)

export default component.exports